import { createSlice } from '@reduxjs/toolkit'
import type { PayloadAction } from '@reduxjs/toolkit'

const initialState: FeatureFlag = {}
export const featureFlagSlice = createSlice({
  name: 'featureFlag',
  initialState,
  reducers: {
    setFeatureFlagInfo: (
      state,
      action: PayloadAction<GetFeatureFlagResponse>
    ) => {
      if (action?.payload?.featureFlagInfo) {
        return action.payload.featureFlagInfo
      }
    }
  }
})
export const { setFeatureFlagInfo } = featureFlagSlice.actions
export const featureFlagReducer = featureFlagSlice.reducer
